<template>
  <div class="lnstructions-box">
    <div class="content">
      <h3>购买小号后请按照以下步骤操作</h3>
      <div class="nr">
        <p>1.使用自己当前App登录的账号进入游戏。</p>
        <p>2.在登录时选择商品详情中对应的小号。</p>
        <img src="../../assets/trade/trade_instructions.png"/>
        <p>3.按照商品说明的区服进入游戏</p>
        <p>4.登录角色</p>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    reactive
  } from 'vue'
  import {
    useRouter
  } from 'vue-router'

  export default {
    name: 'xiaohaolnstructions',
    setup() {
      const router = useRouter()
      const state = reactive({

      })
      const onClickLeft = () => {
        router.back()
      }

      return {
        state,
        onClickLeft
      }
    }
  }
</script>
<style scoped="scoped">
  .lnstructions-box{
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: #f7f8fa;
    overflow-y: auto;
  }
  .lnstructions-box .content{
    padding: 32px;
  }
  .lnstructions-box .content h3{
    font-size: 32px;
    color: #333;
    text-align: center;
    margin-bottom: 31px;
  }
  .lnstructions-box .content .nr{
    padding: 24px;
    background: #f7f8fa;
    border-radius: 15px;
  }
  .lnstructions-box .content .nr p{
    font-size: 30px;
    color: #333;
    margin-bottom: 46px;
    display: flex;
    align-items: center;
  }
  .lnstructions-box .content .nr p i{
    display: block;
    font-style: normal;
    width: 27px;
    height: 25px;
    /* background: url(../../../assets/trade/trade_sm_ico.png) no-repeat center top; */
    background-size: 100% 100%;
    text-align: center;
    line-height: 25px;
    font-size: 20px;
    color: #fff;
    margin-right: 23px;
  }
  .lnstructions-box .content .nr img{
    width: 441px;
    height: 294px;
    display: block;
    margin: 0 auto;
    margin-bottom: 46px;
  }
</style>
